<template>
  <div class="mb-5 overflow-x-auto">
    <nav class="inline-flex min-w-max rounded-xl bg-gray-100 p-1 shadow-sm ring-1 ring-gray-200/70 dark:bg-gray-800/80 dark:ring-gray-700/80">
      <button
        :class="modelValue === 'current'
          ? 'bg-white text-indigo-700 shadow-sm dark:bg-gray-700 dark:text-indigo-300'
          : 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'"
        class="whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-medium transition-colors"
        @click="emit('update:modelValue', 'current')"
      >
        {{ t('app.views.cashRegister.currentSession') || 'Current Session' }}
      </button>

      <button
        :class="modelValue === 'reports'
          ? 'bg-white text-indigo-700 shadow-sm dark:bg-gray-700 dark:text-indigo-300'
          : 'text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200'"
        class="whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-medium transition-colors"
        @click="emit('update:modelValue', 'reports')"
      >
        Sesiones pasadas
      </button>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineProps<{
  modelValue: 'current' | 'reports';
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: 'current' | 'reports'): void;
}>();

const { t } = useI18n();
</script>
